import api from "../api";
import { auth, property } from "../api_endpoints";


export const LoginUser=async(data)=>{
  try {
    const res= await api.post(auth.login, data,{
      headers: {
        'Content-Type': 'application/json',
      },
      // withCredentials:false
    } );
    return res
    
  } catch (error) {
    return error
  }
}

export const RegisterUser=async(data)=>{
  try {
    const res= await api.post(auth.register, data );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const ProfileUser=async(token)=>{
  try {
    const res= await api.get(auth.getProfile,{
      headers: {
        'Authorization':`Bearer ${token}`,
       
      },
    } );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const logoutUser=async(token)=>{
  try {
    console.log(token);
    
    const res= await api.post(auth.logoutUser,{},{
      headers: {
        'Authorization':`Bearer ${token}`,
       
      },
    } );


    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const getProperties=async()=>{
      try {
            const res= await api.get(property.getProperty,{
      headers: {
       
       'Content-Type': 'application/json',
      },
    } );
    console.log(res);
    
    return res
      } catch (error) {
        console.log(error);
        return error
        
      }
}

export const getMenu=async()=>{
      try {
            const res= await api.get(property.getMenu,{
      headers: {
       
       'Content-Type': 'application/json',
      },
    } );
    console.log(res);
    
    return res
      } catch (error) {
        console.log(error);
        return error
        
      }
}

export const getCalender=async()=>{
      try {
            const res= await api.get(property.getCalender,{
      headers: {
       
       'Content-Type': 'application/json',
      },
    } );
    console.log(res);
    
    return res
      } catch (error) {
        console.log(error);
        return error
        
      }
}

export const getMiscellinious=async()=>{
      try {
            const res= await api.get(property.getMiscellaneous,{
      headers: {
       
       'Content-Type': 'application/json',
      },
    } );
    console.log(res);
    
    return res
      } catch (error) {
        console.log(error);
        return error
        
      }
}

export const getDecoration=async()=>{
      try {
            const res= await api.get(property.getDecoration,{
      headers: {
       
       'Content-Type': 'application/json',
      },
    } );
    console.log(res);
    
    return res
      } catch (error) {
        console.log(error);
        return error
        
      }
}



export const getPhotography=async()=>{
      try {
            const res= await api.get(property.getPhotography,{
      headers: {
       
       'Content-Type': 'application/json',
      },
    } );
    console.log(res);
    
    return res
      } catch (error) {
        console.log(error);
        return error
        
      }
}


export const SendEnquiry=async(data)=>{
  try {
    const res= await api.post(property.sendEnquiry, data ,
      {
      headers: {
       
       'Content-Type': 'application/json',
      },
    }
    );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const OrderProperty=async(data,token)=>{
  try {
    const res= await api.post(property.orderProperty, data ,
      {
      headers: {
       'content-type': 'application/json',
        'Authorization':`Bearer ${token}`,
      },
    }
    );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const VerifyPayment=async(data,token)=>{
  try {
    const res= await api.post(property.verifyPayment, data ,
      {
      headers: {
       'content-type': 'application/json',
        'Authorization':`Bearer ${token}`,
      },
    }
    );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}
